<app-modal [title]="isEditing ? 'Editar presupuesto' : 'Cargar presupuesto'">
  <app-form [formGroup]="saveForm">
    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
      <div class="md:col-span-2">
        <app-label for="archivo">Archivo del presupuesto</app-label>
        <app-file-input
          id="archivo"
          accept=".pdf,.doc,.docx,.xls,.xlsx"
          formControlName="archivo"
        />

        @if (isEditing && archivoActual) {
          <div class="mt-3 flex items-center gap-2 rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 dark:border-gray-700 dark:text-gray-300">
            <mat-icon class="text-gray-400">description</mat-icon>
            <span class="truncate">{{ archivoActual }}</span>
            <span class="ml-auto shrink-0 text-xs text-gray-400">Se reemplaza solo si elegís otro archivo</span>
          </div>
        }
      </div>

      <div>
        <app-label for="fecha">Fecha del presupuesto</app-label>
        <app-input-field id="fecha" type="date" formControlName="fecha" />
      </div>

      <div>
        <app-label for="fecha_envio">Fecha de envío</app-label>
        <app-input-field id="fecha_envio" type="date" formControlName="fecha_envio" />
      </div>

      <div>
        <app-label for="fecha_aceptacion">Fecha de aceptación</app-label>
        <app-input-field id="fecha_aceptacion" type="date" formControlName="fecha_aceptacion" />
      </div>

      <!-- Ocultos por ahora: descripción, número y monto.
           Los controles siguen en el form, así que al editar se conservan los valores guardados.
      <div class="md:col-span-2">
        <app-label for="descripcion">Descripción</app-label>
        <app-textarea id="descripcion" formControlName="descripcion" [rows]="3" />
      </div>

      <div>
        <app-label for="presupuesto_nro">Número</app-label>
        <app-input-field id="presupuesto_nro" type="text" formControlName="presupuesto_nro" placeholder="Ej: PRE-2026-001" />
      </div>

      <div>
        <app-label for="monto">Monto (Gs)</app-label>
        <app-input-field id="monto" type="number" formControlName="monto" placeholder="Ej: 560000" />
      </div>
      -->
    </div>
  </app-form>

  <app-creation-buttons *hasPermission="'clientes:create'"
    [valid]="saveForm.valid"
    [process]="loading"
    (onCreateClick)="save()"
    (onCancelClick)="cancel()"
  />
</app-modal>
